"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultReceiptDetail = void 0;
const Alignment_1 = require("../../enums/Alignment");
const LanguageCode_1 = require("../../enums/game/LanguageCode");
const receipt_1 = require("../../enums/receipt");
const RECEIPT_BACKGROUND_IMAGE = 'https://prod-cdn.flarie.com/asset/receipt/receipt-bg.png';
const RECEIPT_WEB_BACKGROUND_IMAGE = 'https://prod-cdn.flarie.com/asset/receipt/receipt-web-bg.png';
exports.defaultReceiptDetail = {
    internalName: '',
    startDateNotReachedText: 'This Receipt Scanner is not yet available',
    expiredText: 'This Receipt Scanner is no longer available',
    additionalTermsText: '',
    status: receipt_1.ReceiptStatusType.DRAFT,
    startDate: null,
    endDate: null,
    playerIdentifier: receipt_1.ReceiptPlayerIdentifierType.EMAIL,
    emailInputField: 'Email',
    registerBackgroundImage: RECEIPT_BACKGROUND_IMAGE,
    scanBackgroundImage: RECEIPT_BACKGROUND_IMAGE,
    scanWebBackgroundImage: RECEIPT_WEB_BACKGROUND_IMAGE,
    language: LanguageCode_1.LanguageCode.English,
    isTermsCheckboxEnabled: true,
    termsConditionsText: 'I accept the <strong>Terms & Policies</strong>',
    termsTextStyle: {
        fontSize: '12px',
        color: '000000',
        textAlign: Alignment_1.Alignment.LEFT,
    },
    termsButtonText: 'Flarie ® Terms & Policies',
    termsButtonStyle: {
        fontSize: '12px',
        color: 'ffffff',
        textAlign: Alignment_1.Alignment.CENTER,
    },
    playerEditSetting: {
        date: false,
        product: false,
        price: false,
        store: false,
    },
    numberOfReceipt: 0,
};
